export default __webpack_public_path__ + "static/media/TVP_WEB.63a17278.svg";